import {pullRequestsAppBuilder} from '../config/app-builder'
import {mainQuery} from '@github-ui/react-core/future/main-query'
import type {FilesRoutePayload} from './route-payload-types'

export const pullRequestsFilesRoute = pullRequestsAppBuilder.createQueryRouteConfig('pullRequestsFilesRoute', {
  path: '/:owner/:repo/pull/:pr_number/files',
  queries: [
    mainQuery<FilesRoutePayload>({
      staleTime: 0,
    }),
  ],
})

export const pullRequestsFilesWithRangeRoute = pullRequestsAppBuilder.createQueryRouteConfig(
  'pullRequestsFilesWithRangeRoute',
  {
    path: '/:owner/:repo/pull/:pr_number/files/:range',
    queries: [
      mainQuery<FilesRoutePayload>({
        staleTime: 0,
      }),
    ],
  },
)
